export const Arrow = ({ className }: { className?: string }) => {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.5441 5.80016L8.17613 10.1682L7.37813 9.46816L11.0601 5.80016H0.630127V4.73616H11.0601L7.37813 1.06816L8.17613 0.368164L12.5441 4.73616V5.80016Z"
        fill="#343434"
      />
    </svg>
  );
};
